import React, { useState, useRef, useEffect } from "react";
import PropTypes from "prop-types";
import { CircularProgress } from "@mui/material";

import { useNetwork } from "../../../context/NetworkContext";
import { useShowAlert } from "../../../context/AlertContext";
import AxiosInstance from "../../../utils/AxiosInstance";
import Messages from "../../../constants/Messages";
import handleError from "../../../constants/handleError";
import CustomerModal from "../sale/CustomerModal";
import EditCutomer from "../customer/EditCustomer";
import { usePermission } from "../../../context/PermissionContext";
import AddCustomer from "../customer/AddCustomer";
import { useAuth } from "../../../context/AuthProvider";
import { useContextApi } from "../../../context/ContextApi";
import SearchInput from "../../../constants/SearchInput";
import ProductSearchList from "../../../constants/ProductSearchList";
import { AddIcon, EditIcon, MinusIcon, XIcon } from "../../../constants/Icons";

const AddPaylater = ({ onClose, onAdd, isBtnLoading, isActive }) => {
  const [formData, setFormData] = useState({
    paymentmode: "",
    amount: 0,
  });
  const [isBtnsLoading, setBtnsLoading] = useState(false);
  const { useEscapeKey } = useContextApi();
  const paymentmode = ["CASH", "CARD", "UPI"];
  const { updateSettings } = useAuth();
  const [selectedIndex, setSelectedIndex] = useState(0);
  const inputRefs = useRef([]);
  const [numberSuggest, setNumberSuggest] = useState([]);
  const {
    customerSearchTerm,
    customerSuggestions,
    setCustomerSearchTerm,
    isCustomerData,
    setCustomerData,
    handleCustomerSearch,
    setCustomerSuggestions,
  } = useContextApi();
  const customerSuggestionsRef = useRef(null);
  const [isCustomerLoading, setIsCustomerLoading] = useState(false);
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [showCustomerDropdown, setShowCustomerDropdown] = useState(false);
  const [highlightedIndex, setHighlightedIndex] = useState(-1);
  const suggestionRefs = useRef([]);
  const [isLoading, setLoading] = useState(false);
  const [isCustomerModalOpen, setCustomerModalOpen] = useState(false);
  const [isEditModalOpen, setEditModalOpen] = useState(false);
  const [isEditData, setEditData] = useState(null);
  const { checkNetwork } = useNetwork();
  const showAlert = useShowAlert();
  const [errors, setErrors] = useState({});
  const paymodeRef = useRef(null);
  const paymentmodeRef = useRef(null);
  const amountRef = useRef([]);
  const buttonRef = useRef();
  const debounceTimerRef = useRef(null);
  const controllerRef = useRef(null);
  const { customerGroups, blockedPermissions, permission } = usePermission();
  const [addGroupload, setAddGroupLoad] = useState(false);
  const [addNewGroupOpen, setNewGroupOpen] = useState(false);
  const [newGroupName, setNewGroupName] = useState(null);
  const [groupName, setGroupName] = useState(customerGroups);

  const validateForm = () => {
    const errs = {};
    if (
      !formData.amount[selectedIndex] ||
      formData.amount[selectedIndex].trim() === ""
    ) {
      errs.amount = Messages.ERROR.AMOUNT_EMPTY;
    } else if (!selectedCustomer) {
      customerSuggestionsRef.current.focus();
      errs.customer = "customer cannot be empty";
    }

    setErrors(errs);

    if (Object.keys(errs).length > 0) {
      const firstError = Object.keys(errs)[0];
      setTimeout(() => {
        if (firstError === "amount") {
          amountRef.current?.[selectedIndex]?.focus();
        } else if (firstError === "customer") {
          customerSuggestionsRef.current?.focus();
        }
      }, 10);

      return false;
    }
    return Object.keys(errs).length === 0;
  };

  const handleChange = (field, value, index) => {
    setErrors("");

    if (field === "amount") {
      const regex = /^\d+(\.\d{0,2})?$/;
      if (value === "" || regex.test(value)) {
        setFormData((prev) => ({
          ...prev,
          paymentmode: paymentmode[index],
          amount: {
            [index]: value,
          },
          index: index,
        }));
      }
      return;
    }

    setFormData((prev) => ({
      ...prev,
      paymentmode: paymentmode[index],
      amount: {
        [index]: value,
      },
      index: index,
    }));
  };

  const handleSubmit = (e, paymode) => {
    e.preventDefault();
    if (!validateForm()) return;

    const AddData = {
      ...formData,
      paymode: paymode,
      selectedCustomerId: selectedCustomer.customerData._id,
    };
    onAdd(AddData);
  };

  const handleClose = () => {
    setErrors({});
    setFormData({ paymode: "", amount: "" });
    onClose();
  };
  useEscapeKey(handleClose);
  const stopEventPropagation = (e) => e.stopPropagation();

  const handleFieldInteraction = (
    fieldName,
    eventType = "focus",
    keyEvent = null,
  ) => {
    // setErrors((prev) => ({ ...prev, [fieldName]: "" }));

    if (keyEvent?.key === "Enter") {
      keyEvent.preventDefault();
      if (fieldName === "amount") {
        if (formData.amount.trim()) {
          paymodeRef.current?.focus();
        } else {
          setErrors((prev) => ({
            ...prev,
            amount: Messages.ERROR.AMOUNT_EMPTY,
          }));
        }
      }
      //   if (fieldName === "paymentMode") {
      //     if (formData.paymentMode.trim()) {
      //       paymodeRef.current?.focus();
      //     } else {
      //       setErrors((prev) => ({
      //         ...prev,
      //         paymentmode: "Pay mode cannot be empty",
      //       }));
      //     }
      //   }
    }
  };
  const handlePaymodeKeyDown = (e) => {
    if (e.key === "Enter" && formData.paymode.trim()) {
      e.preventDefault();
      handleSubmit(e);
    }
  };

  const handleCustomerModalOpen = () => {
    setSelectedCustomer(null);
    setCustomerModalOpen(true);
  };

  const handleCustomerModalClose = () => {
    setCustomerModalOpen(false);
    setCustomerData(null);
  };

  const handleResetCustomer = () => {
    setCustomerModalOpen(false);
    setCustomerData(null);
  };

  const handleCustomerAdd = async (newData) => {
    setBtnsLoading(true);
    try {
      if (!checkNetwork()) return;
      const data = {
        ...newData,
        shippingAddress: {
          addressline1: newData.shippingaddressline1,
          addressline2: newData.shippingaddressline2,
          district: newData.shippingdistrict,
          city: newData.shippingcity,
          state: newData.shippingstate,
          statecode: newData.shippingstatecode,
          country: newData.shippingcountry,
          pincode: newData.shippingpincode,
        },

        ...(newData.contactPersonname?.trim() ||
        newData.contactPersonNumber?.trim()
          ? {
              contactPerson: {
                ...(newData.contactPersonname?.trim() && {
                  name: newData.contactPersonname,
                }),
                ...(newData.contactPersonNumber?.trim() && {
                  number: newData.contactPersonNumber,
                }),
              },
            }
          : {}),
      };
      const response = await AxiosInstance.post(`module/customer`, data);
      showAlert("success", Messages.SUCCESS.CUSTOMER_ADDED);
      const result = response.data.results;
      if (result.name !== newData.name) {
        showAlert(
          "warning",
          `The phone number"${result.phone}" already exists .`,
        );
        // handleCloseModal();
        return true;
      }
      handleResetCustomer();
      handleSelectCustomer(response.data.results);
      return true;
    } catch (error) {
      if (
        error.response &&
        error.response.status === 409 &&
        error.response.data &&
        error.response.data.code === "DUPLICATE_ENTRY"
      ) {
        const errorMessage = error.response.data.message;
        let fieldError = {};

        // if (errorMessage.includes("ReferenceId already exists")) {
        //     fieldError.referenceid = "Reference ID already exists .";
        // }
        if (errorMessage.includes("GST number already exists")) {
          fieldError.gstnumber = "GST number already exists.";
        }

        if (Object.keys(fieldError).length > 0) {
          setErrors((prev) => ({ ...prev, ...fieldError }));
        } else {
          handleError(error, showAlert);
        }

        return false;
      } else {
        handleError(error, showAlert);
        return false;
      }
    } finally {
      setBtnsLoading(false);
    }
  };

  const openEditModal = (cItem) => {
    if (
      blockedPermissions("CUSTOMER:viewDetails") ||
      permission === undefined
    ) {
      setEditData(cItem);
      setEditModalOpen(true);
    } else {
      showAlert("warning", Messages.AUTH.PERMISSION_REQUIRED);
    }
  };

  const handleUpdte = async (updatedData) => {
    const editableKeys = [
      "name",
      "phone",
      "email",
      "addressline1",
      "addressline2",
      "city",
      "district",
      "state",
      "pincode",
      "country",
      "gstnumber",
      "pannumber",
      "cinnumber",
      "referenceid",
      "isPayLater",
      "groupid",
      "fssai",
      "tradeName",
      "nickname",
      "contactPersonname",
      "contactPersonNumber",
      "shippingaddressline1",
      "shippingaddressline2",
      "shippingstate",
      "shippingcity",
      "shippingdistrict",
      "shippingpincode",
      "shippingcountry",
      "website",
    ];

    let hasChange = false;
    for (const key of editableKeys) {
      const originalValue = String(isEditData[key] || "");
      const updatedValue = String(updatedData[key] || "");
      if (originalValue !== updatedValue) {
        hasChange = true;
        break;
      }
    }
    if (!hasChange) {
      showAlert("warning", "No changes detected.");
      return false;
    }
    setBtnsLoading(true);
    try {
      if (!checkNetwork()) return;
      const data = {
        ...updatedData,
        shippingAddress: {
          addressline1: updatedData.shippingaddressline1,
          addressline2: updatedData.shippingaddressline2,
          district: updatedData.shippingdistrict,
          city: updatedData.shippingcity,
          state: updatedData.shippingstate,
          statecode: updatedData.shippingstatecode,
          country: updatedData.shippingcountry,
          pincode: updatedData.shippingpincode,
        },

        // ✅ Contact Person Object
        ...(updatedData.contactPersonname?.trim() ||
        updatedData.contactPersonNumber?.trim()
          ? {
              contactPerson: {
                ...(updatedData.contactPersonname?.trim() && {
                  name: updatedData.contactPersonname,
                }),
                ...(updatedData.contactPersonNumber?.trim() && {
                  number: updatedData.contactPersonNumber,
                }),
              },
            }
          : {}),
        customerid: updatedData._id,
      };
      const response = await AxiosInstance.patch(
        `module/customer/${updatedData._id}`,
        data,
      );

      showAlert("success", Messages.SUCCESS.CUSTOMER_UPDATED);
      setCustomerData(response.data.results);
      setSelectedCustomer((prev) => ({
        ...prev,
        customerData: response.data.results,
      }));
      closeEditModal();
      return true;
    } catch (error) {
      if (
        error.response &&
        error.response.status === 409 &&
        error.response.data &&
        error.response.data.code === "DUPLICATE_ENTRY"
      ) {
        const errorMessage = error.response.data.message;
        let fieldError = {};

        // if (errorMessage.includes("ReferenceId already exists")) {
        //     fieldError.referenceid = "Reference ID already exists .";
        // }
        if (errorMessage.includes("GST number already exists")) {
          fieldError.gstnumber = "GST number already exists.";
        }

        if (Object.keys(fieldError).length > 0) {
          setErrors((prev) => ({ ...prev, ...fieldError }));
        } else {
          handleError(error, showAlert);
        }

        return false;
      } else {
        handleError(error, showAlert);
        return false;
      }
    } finally {
      setBtnsLoading(false);
    }
  };

  // console.log(selectedCustomer);

  const closeEditModal = () => {
    setEditData(null);
    setEditModalOpen(false);
  };

  const handleSelectCustomer = async (customer) => {
    setErrors("");
    try {
      if (!checkNetwork()) return;
      const response = await AxiosInstance.get(
        `module/customer/details/${customer._id}`,
      );
      const fullCustomer = response.data.results;
      setSelectedCustomer(fullCustomer);
      setCustomerSearchTerm("");
      setCustomerSuggestions([]);
    } catch (error) {
      handleError(error, showAlert);
    }

    // Store customer inside active cart
    // updateActiveCart((cart) => ({
    //   ...cart,
    //   customer,
    // }));
  };

  const handleCustomerKeyDown = (e) => {
    if (e.key === "ArrowDown") {
      e.preventDefault();
      setHighlightedIndex((prev) =>
        Math.min(prev + 1, customerSuggestions.length - 1),
      );
    } else if (e.key === "ArrowUp") {
      e.preventDefault();
      setHighlightedIndex((prev) => Math.max(prev - 1, 0));
    } else if (e.key === "Enter") {
      e.preventDefault();

      const trimmedSearch = customerSearchTerm.trim();

      if (trimmedSearch === "") {
        amountRef.current[0]?.focus();
        return;
      }

      const noSelection = highlightedIndex === -1;
      const hasExactMatch = customerSuggestions.some((customer) => {
        const nameMatch =
          customer.name.toLowerCase() === trimmedSearch.toLowerCase();
        const phoneMatch = customer.phone === trimmedSearch;
        return nameMatch || phoneMatch;
      });

      if (noSelection && !hasExactMatch) {
        handleCustomerModalOpen();
        return;
      }

      if (highlightedIndex >= 0) {
        const selected = customerSuggestions[highlightedIndex];
        handleSelectCustomer(selected);
        customerSuggestionsRef.current?.focus();
        setShowCustomerDropdown(false);
        setCustomerSearchTerm("");
        setHighlightedIndex(-1);
      }
    }
  };

  const handleKeyNavigation = (e, index) => {
    if (e.key === "ArrowDown") {
      e.preventDefault();
      if (index < paymentmode.length - 1) {
        setSelectedIndex(index + 1);
      }
    } else if (e.key === "ArrowUp") {
      e.preventDefault();
      if (index > 0) {
        setSelectedIndex(index - 1);
      }
    } else if (e.key === "Enter") {
      e.preventDefault();
    }
  };

  const handleNewGroupClose = () => {
    setNewGroupOpen(false);
  };

  const handleNewGroupOpen = () => {
    setNewGroupOpen(true);
  };
  const handleCustomerGroupAdd = async (groupName, method) => {
    setAddGroupLoad(true);
    try {
      const data = {
        name: groupName,
      };
      const response = await AxiosInstance.post("module/customer/group", data);
      const results = response.data.results;
      //  setGroupName(results);
      setGroupName((prev) => [
        { ...results },
        ...(Array.isArray(prev) ? prev : []),
      ]);
      updateSettings({
        customerGroups: [
          { ...results },
          ...(Array.isArray(customerGroups) ? customerGroups : []),
        ],
      });
      showAlert("success", "Customer Group Added Successfull");
      setAddGroupLoad(false);
      handleNewGroupClose();
      setNewGroupName(results);
      if (method === "ADD") {
        handleCustomerModalOpen();
      } else {
        openEditModal(isEditData);
      }
    } catch (error) {
      handleError(error, showAlert);
      return false;
    } finally {
      setAddGroupLoad(false);
    }
  };

  // const handleCustomerNumbersuggestion = async () => {
  //   if (!checkNetwork()) return;
  //   try {
  //     const response = await AxiosInstance("module/customer/suggestion/phone");
  //     const result = response.data.results;
  //     setNumberSuggest(result);
  //   } catch (error) {
  //     handleError(error, showAlert);
  //     return false;
  //   }
  // };

  const addNewCustomNumber = (phone) => {
    const trimmed = phone?.trim();

    if (!trimmed) return; // ignore empty/whitespace input

    const exists = numberSuggest?.some(
      (s) => s.phone?.toLowerCase() === trimmed?.toLowerCase(),
    );

    if (!exists) {
      setNumberSuggest((prev) => [
        { _id: Date.now().toString(), phone: trimmed },
        ...prev,
      ]);
    }
  };

  const handleOutsideClick = (e) => {
    if (
      customerSuggestionsRef.current &&
      !customerSuggestionsRef.current.contains(e.target)
    ) {
      setCustomerSuggestions([]);
      setCustomerSearchTerm("");
      setCustomerData("");
    }
  };

  useEffect(() => {
    const current = amountRef.current[selectedIndex];
    if (current) current.focus();
  }, [selectedIndex]);

  useEffect(() => {
    if (customerSuggestionsRef.current) {
      customerSuggestionsRef.current.focus();
    }
    // handleCustomerNumbersuggestion();
  }, []);

  useEffect(() => {
    document.addEventListener("click", handleOutsideClick);
    return () => {
      document.removeEventListener("click", handleOutsideClick);
    };
  }, []);
  return (
    <div>
      <div className="modal-backdrop show"></div>
      <div
        className="modal show d-block"
        id="StoreModal"
        tabIndex="0"
        aria-modal="true"
        role="dialog"
      >
        <div
          className="modal-dialog modal-dialog-centered modal-dialog-scrollable"
          onClick={stopEventPropagation}
        >
          <div className="modal-content">
            <div className="modal-header">
              <h6 className="modal-title">Add Paylater</h6>
              <button
                type="button"
                className="btn-close"
                onClick={handleClose}
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <div className="card w-100 radius-10 mb-0 shadow-none">
                <div className="card-body p-0">
                  <div className="row g-3">
                    <div className="col-lg-12">
                      <div className="card">
                        <div className="card-body">
                          <div className="ms-auto position-relative">
                            <SearchInput
                              searchRef={customerSuggestionsRef}
                              value={customerSearchTerm}
                              onChange={(e) => {
                                handleCustomerSearch(e.target.value);
                                setShowCustomerDropdown(true);
                                setHighlightedIndex(-1);
                              }}
                              onFocus={() => {
                                if (customerSuggestions.length > 0) {
                                  setShowCustomerDropdown(true);
                                }
                              }}
                              onSearch={
                                customerSearchTerm.trim()
                                  ? () =>
                                      handleCustomerModalOpen(
                                        customerSearchTerm.trim(),
                                      )
                                  : null
                              }
                              placeholder="Search customer by name, phone, email, referenceID..."
                              onKeyDown={handleCustomerKeyDown}
                            />
                            {customerSearchTerm &&
                              customerSuggestions.length === 0 && (
                                <ul className="suggestions-list">
                                  <li className="suggestion-item text-muted">
                                    No customers data was found
                                  </li>
                                </ul>
                              )}
                            {showCustomerDropdown &&
                              customerSuggestions.length > 0 && (
                                <ProductSearchList 
                                suggest={customerSuggestions}
                                suggestionRefs={suggestionRefs}
                                handleSelect={handleSelectCustomer}
                                activeIndex={highlightedIndex}
                                type="customer"
                                />
                                // <ul className="suggestions-list">
                                //   {customerSuggestions.map(
                                //     (customer, index) => (
                                //       <li
                                //         ref={(el) =>
                                //           (suggestionRefs.current[index] = el)
                                //         }
                                //         key={customer._id}
                                //         onClick={() =>
                                //           handleSelectCustomer(customer)
                                //         }
                                //         className={`suggestion-item ${
                                //           highlightedIndex === index
                                //             ? "highlighted"
                                //             : ""
                                //         }`}
                                //       >
                                //         {customer.name} -{" "}
                                //         <span className="badge badge-primary badge bg-label-blue rounded-pill">
                                //           {customer.phone}
                                //         </span>
                                //         {customer.referenceid && (
                                //           <>
                                //             <small>-</small>{" "}
                                //             <span className="badge badge-info badge bg-label-secondary rounded-pill">
                                //               {customer.referenceid}
                                //             </span>
                                //           </>
                                //         )} 
                                //       </li>
                                //     ),
                                //   )}
                                // </ul>
                              )}
                          </div>
                          <div className="col-lg-12 mt-1">
                            <div className="card shadow-none border-blue mb-0">
                              <div className="card-header bg-label-infoss p-2 d-flex justify-content-between align-items-center ">
                                <div className="mb-0">Customer Info</div>
                                {selectedCustomer?.customerData && (
                                  <div>
                                    <button
                                      type="button"
                                      className="bg-label-infoss rounded  shadow-none border-0"
                                      onClick={() =>
                                        openEditModal(
                                          selectedCustomer.customerData,
                                        )
                                      }
                                    >
                                      <EditIcon/>
                                    </button>
                                  </div>
                                )}
                              </div>
                              <div className="card-body px-2 py-0">
                                {selectedCustomer ? (
                                  <>
                                    <p className="my-1 fs-13">
                                      Name :{" "}
                                      <span className="fw-600 fs-14">
                                        {selectedCustomer.customerData.name}
                                      </span>
                                    </p>
                                    <p className="my-1 fs-13">
                                      Phone :{" "}
                                      <span className="fw-600 fs-14">
                                        {
                                          selectedCustomer.customerData.phone
                                        }{" "}
                                      </span>
                                    </p>
                                    {selectedCustomer.referenceid && (
                                      <p className="my-1 fs-13">
                                        Reference ID :{" "}
                                        <span className="fw-600 fs-14">
                                          {
                                            selectedCustomer.customerData
                                              .referenceid
                                          }
                                        </span>
                                      </p>
                                    )}
                                  </>
                                ) : (
                                  <p className="my-2 text-muted">
                                    No customers has been selected
                                  </p>
                                )}
                              </div>
                            </div>
                          </div>
                          {errors.customer && (
                            <div className="error-message invalid-feedback">
                              {errors.customer}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-12">
                      <table className="table align-middle mb-0">
                        <thead className="table-light">
                          <tr>
                            <th></th>
                            <th className="text-center">Payment Mode</th>
                            <th className="text-center">Amount</th>
                          </tr>
                        </thead>
                        <tbody>
                          {paymentmode.map((item, index) => (
                            <tr
                              key={index}
                              className={`position-relative cursor-pointer hover-row ${selectedIndex === index ? "selected-row" : ""}`}
                              // style={{
                              //   backgroundColor:
                              //     selectedIndex === index
                              //       ? "#f0f8ff"
                              //       : "transparent",
                              // }}
                              onClick={() => setSelectedIndex(index)}
                            >
                              <td>
                                <input
                                  type="radio"
                                  name="productSelection"
                                  checked={selectedIndex === index}
                                  onChange={() => setSelectedIndex(index)}
                                />
                              </td>
                              <td className="text-center">
                                <span className="badge bg-label-space">
                                  {item}
                                </span>
                              </td>
                              <td>
                                <input
                                  type="text"
                                  className="form-control text-center"
                                  value={formData.amount[index] || ""}
                                  onChange={(e) => {
                                    // if (selectedIndex !== index) {
                                    setSelectedIndex(index);
                                    // }
                                    handleChange(
                                      "amount",
                                      e.target.value,
                                      index,
                                    );
                                  }}
                                  onKeyDown={(e) =>
                                    handleKeyNavigation(e, index)
                                  }
                                  onFocus={(e) => {
                                    e.target.select();
                                    setSelectedIndex(index); // Select radio on focus
                                  }}
                                  ref={(el) => {
                                    if (el !== null) {
                                      if (!Array.isArray(amountRef.current)) {
                                        amountRef.current = [];
                                      }
                                      amountRef.current[index] = el;
                                    }
                                  }}
                                />
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                    {/* <div className="col-lg-6">
                      <label className="form-label">
                        Amount <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        value={formData.amount}
                        onChange={(e) => handleChange("amount", e.target.value)}
                        // onFocus={() => handleFieldInteraction("amount")}
                        // onMouseDown={() => handleFieldInteraction("amount")}
                        onKeyDown={(e) =>
                          handleFieldInteraction("amount", "keydown", e)
                        }
                        ref={amountRef}
                      />
                      {errors.amount && (
                        <div className="error-message invalid-feedback">
                          {errors.amount}
                        </div>
                      )}
                    </div> */}
                    {/* <div className="col-lg-6">
                      <label className="form-label">
                        Pay Mode <span className="text-danger">*</span>
                      </label>
                      <select
                        className="form-select"
                        value={formData.paymentMode}
                        onChange={(e) =>
                          handleChange("paymentMode", e.target.value)
                        }
                        onKeyDown={(e) =>
                          handleFieldInteraction("paymentMode", "keydown", e)
                        }
                        ref={paymentmodeRef}
                      >
                        <option value="">Select</option>
                        <option value="PAYOUT">PAYOUT</option>
                        <option value="PAYIN">PAYIN</option>
                      </select>
                      {errors.paymentmode && (
                        <div className="error-message invalid-feedback">
                          {errors.paymentmode}
                        </div>
                      )}
                    </div> */}
                    {/* <div className="col-lg-6">
                      <label className="form-label">
                        Payment Mode <span className="text-danger">*</span>
                      </label>
                      <select
                        className="form-select"
                        value={formData.paymode}
                        onChange={(e) =>
                          handleChange("paymode", e.target.value)
                        }
                        onKeyDown={handlePaymodeKeyDown}
                        ref={paymodeRef}
                      >
                        <option value="">Select</option>
                        <option value="CASH">CASH</option>
                        <option value="CARD">CARD</option>
                        <option value="UPI">UPI</option>
                        <option value="OTHER">OTHERS</option>
                      </select>
                      {errors.paymode && (
                        <div className="error-message invalid-feedback">
                          {errors.paymode}
                        </div>
                      )}
                    </div> */}
                  </div>
                </div>
              </div>
            </div>

            <div className="modal-footer d-block">
              <button
                type="button"
                className="btn btn-outline-secondary text-left"
                onClick={handleClose}
              >
                <XIcon/> Cancel
              </button>

              {isBtnLoading.payIn ? (
                <button className="btn btn-success pb-0 text-right" disabled>
                  <CircularProgress size={22} className="text-white" />
                </button>
              ) : (
                <button
                  ref={buttonRef}
                  type="button"
                  className="btn btn-success text-right"
                  onClick={(e) => handleSubmit(e, "PAYIN")}
                >
                  <AddIcon/> Pay In
                </button>
              )}
              {isBtnLoading.payOut ? (
                <button className="btn btn-danger pb-0 text-right" disabled>
                  <CircularProgress size={22} className="text-white" />
                </button>
              ) : (
                <button
                  ref={buttonRef}
                  type="button"
                  className="btn btn-danger text-right"
                  onClick={(e) => handleSubmit(e, "PAYOUT")}
                >
                  <MinusIcon/> Pay Out
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
      {/* {isCustomerModalOpen && (
        <CustomerModal
          onClose={handleCustomerModalClose}
          onConfirm={handleCustomerAdd}
          onData={isCustomerData}
          isBtnLoading={isBtnLoading}
          groupName={groupName}
          onNewGroupsIn={handleCustomerGroupAdd}
          newGroup={newGroupName}
        />
      )} */}

      <AddCustomer
        isActive={isActive}
        isOpen={isCustomerModalOpen}
        onClose={handleCustomerModalClose}
        onData={isCustomerData}
        onAdd={handleCustomerAdd}
        isBtnLoading={isBtnsLoading}
        groupName={groupName}
        onNewGroupsIn={handleCustomerGroupAdd}
        newGroup={newGroupName}
        resetAll={true}
        error={errors}
        setErrors={setErrors}
        numberSuggest={numberSuggest}
        addNewCustomNumber={addNewCustomNumber}
      />

      {isEditModalOpen && (
        <EditCutomer
          isActive={isActive}
          editData={isEditData}
          onClose={closeEditModal}
          onEdit={handleUpdte}
          isBtnLoading={isBtnsLoading}
          groupName={groupName}
          groupId={selectedCustomer.customerData?.groupid}
          onNewGroupsIn={handleCustomerGroupAdd}
          resetAll={true}
          newGroup={newGroupName}
          error={errors}
          setErrors={setErrors}
        />
      )}
    </div>
  );
};

AddPaylater.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onAdd: PropTypes.func.isRequired,
};

export default AddPaylater;
